'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _QuickReply = require('./QuickReply');

var _QuickReply2 = _interopRequireDefault(_QuickReply);

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _QuickReplyModel = require('conversations-schema/models/QuickReplyModel');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var QuickReplyGroup = _react2.default.createClass({
  displayName: 'QuickReplyGroup',

  propTypes: {
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    disabled: _react.PropTypes.bool,
    hasSentReply: _react.PropTypes.bool.isRequired,
    multiSelect: _react.PropTypes.bool.isRequired,
    onSend: _react.PropTypes.func.isRequired,
    options: _react.PropTypes.instanceOf(_immutable.Set).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      multiSelect: false,
      hasSentReply: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      selected: (0, _immutable.Set)()
    };
  },
  hasSelected: function hasSelected() {
    var selected = this.state.selected;


    return selected.size > 0;
  },
  handleSelect: function handleSelect(option) {
    this.setState(function (_ref) {
      var selected = _ref.selected;

      var updatedSelected = selected.includes(option) ? selected.delete(option) : selected.add(option);

      return { selected: updatedSelected };
    });
  },
  handleSendMulti: function handleSendMulti() {
    var _props = this.props,
        multiSelect = _props.multiSelect,
        onSend = _props.onSend;
    var selected = this.state.selected;


    var canSendMultiple = multiSelect && this.hasSelected();

    if (canSendMultiple) {
      var text = selected.map(_QuickReplyModel.getOptionLabel).join(', ');

      onSend(text, selected);
    }
  },
  handleSendIndividual: function handleSendIndividual(option) {
    var _props2 = this.props,
        multiSelect = _props2.multiSelect,
        onSend = _props2.onSend;


    var canSendIndividual = !multiSelect;

    if (canSendIndividual) {
      var options = (0, _immutable.List)([option]);
      var text = (0, _QuickReplyModel.getOptionLabel)(option);

      onSend(text, options);
    }
  },
  renderOptions: function renderOptions() {
    var _props3 = this.props,
        options = _props3.options,
        multiSelect = _props3.multiSelect,
        coloring = _props3.coloring,
        disabled = _props3.disabled;
    var selected = this.state.selected;


    var onClick = multiSelect ? this.handleSelect : this.handleSendIndividual;

    return options.map(function (option) {
      var boundOnClick = function boundOnClick() {
        return onClick(option);
      };
      var checked = selected.includes(option);

      var value = (0, _QuickReplyModel.getOptionValue)(option);
      var label = (0, _QuickReplyModel.getOptionLabel)(option);

      var checkbox = multiSelect && _react2.default.createElement(_UICheckbox2.default, {
        className: 'm-right-2',
        style: { minHeight: 10 },
        size: 'small',
        color: coloring.accentColor,
        checked: checked,
        onChange: boundOnClick
      });

      return _react2.default.createElement(
        _QuickReply2.default,
        {
          disabled: disabled,
          key: 'quickreply.' + value,
          onClick: boundOnClick,
          coloring: coloring
        },
        checkbox,
        label
      );
    });
  },
  renderSendButton: function renderSendButton() {
    var _props4 = this.props,
        disabled = _props4.disabled,
        multiSelect = _props4.multiSelect,
        coloring = _props4.coloring;


    if (!multiSelect) {
      return null;
    }

    var disableQuickReply = disabled || !this.hasSelected();

    return _react2.default.createElement(
      _QuickReply2.default,
      {
        key: 'send-button',
        use: 'primary',
        coloring: coloring,
        disabled: disableQuickReply,
        onClick: this.handleSendMulti
      },
      _react2.default.createElement(_UIIcon2.default, { name: 'check' })
    );
  },
  render: function render() {
    var hasSentReply = this.props.hasSentReply;


    if (hasSentReply) {
      return null;
    }

    var content = [].concat(_toConsumableArray(this.renderOptions()), [this.renderSendButton()]);

    return _react2.default.createElement(
      'div',
      { className: 'align-center flex-wrap m-y-2' },
      content
    );
  }
});

exports.default = QuickReplyGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/QuickReplyGroup.js
// module id = 1126
// module chunks = 2 3